module.exports = __webpack_public_path__ + "static/media/vivi-em-pe.e3f81365.svg";